import { Component } from "@angular/core";

@Component({
  selector: "app-core",
  template: `<router-outlet></router-outlet>`,
})
export class CoreComponent {
  constructor() {}
}
